const en_trans_itemmove = {
    "": "item transfer",

    label: {
        goods_t: "item quantity",
        delivery_dest: "delivery destination",
        qty_t: "total quantity",
    },

    error: {
        create: "Failed to transfer item",
        edit: "Failed to update item transfer",
    },

    success: {
        create: "Item transfer completed successfully",
        edit: "Item transfer updated successfully",
    },
}

export default en_trans_itemmove;